<div
  class="bz-progress"
  role="progressbar"
  [attr.aria-valuenow]="percent()"
  aria-valuemin="0"
  aria-valuemax="100"
  [attr.aria-label]="ariaLabel() || null"
>
  <div [class]="barClass()" [style.width.%]="percent()"></div>
</div>
